import React, {useEffect, createRef} from 'react';
import {useInView} from "react-intersection-observer";
import anime from 'animejs';
import styled from 'styled-components';

const Data = styled.h1`
  font-size: 1.1rem;
  font-weight: 700;
  color: ${({color}) => color ? color : '#635BFF'};
  margin: 0 0 1rem;
  transition: all .5s ease;
`;
const Character = styled.span`
  opacity: 0;
`;

const Heading = ({className, color, children, level = 1}) => {
  let charRefs = [];
  let textSpans = [];
  for (let i = 0; i < children.length; i++) {
    charRefs[i] = createRef(null);
    textSpans[i] = <Character key={i} ref={charRefs[i]}>{children[i]}</Character>;
  }

  const [ref, inView] = useInView({
    triggerOnce: true
  });

  useEffect(() => {
    const targets = Array.from(charRefs, el => el.current);

    if (inView) {
      anime({
        targets: targets,
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 500,
        delay: (el, i) => 250 + 30 * i
      });
    }
    return () => anime({
      targets: targets,
      opacity: 0,
      easing: "easeOutExpo",
      duration: 10,
    });
  }, [inView]);

  return <Data className={className} color={color} ref={ref} as={'h' + level}>{textSpans}</Data>;
};

export default Heading;